//change sezzle logo for dtc new product page experint
const sezzleLogo = document.querySelector('.sezzle-logo');
const alternateLogoSrc = 'https://cdn.shopify.com/s/files/1/0350/5061/9020/files/Color-White-Logo_2.png?v=1686586934';
if (sezzleLogo) {
    sezzleLogo.src = alternateLogoSrc;
}